import { createSelector } from 'reselect'

import { RootState } from '../../types'

export const selectState = createSelector(
  (s: RootState) => s.accountUser,
  b => b
)

export const getAccountUserData = createSelector(selectState, s => s.data)

export const areAccountUserDataLoading = createSelector(selectState, s => s.loading)

export const getRegistrationType = createSelector(getAccountUserData, s => s?.accounting.registrationType)

export const getBillingCountryCode = createSelector(getAccountUserData, s => s.accounting?.billingAddress?.countryCode)

export const getBillingEmailAddress = createSelector(
  getAccountUserData,
  s => s.accounting?.billingAddress?.billingEmailAddress
)

export const getUserType = createSelector(getAccountUserData, user => user.crifAccount.userType)

export const getAccountingData = createSelector(getAccountUserData, x => x.accounting)
